module.exports = __webpack_public_path__ + "img/img23.a7943916.jpg";